import request from '@/utils/request'

export function getConsentForm() {
  return request({ url: '/admin/consent-form/detail', method: 'post', data: {} })
}

export function saveConsentForm(data) {
  return request({ url: '/admin/consent-form/save', method: 'post', data })
}
